import { atom } from "jotai";

import { SimpleResult } from "../simple-result/simple-result";

/** Whether the last-triggered ДПС read is still in flight. */
export const apiLoadingAtom = atom<boolean>(false);

/** The last-triggered ДПС read's failure, or `null` — set by whichever hook ran last. */
export const apiErrorAtom = atom<SimpleResult<unknown> | null>(null);
